import { deriveTitle, isUsableUrlTitle, type Note, type UrlEntity } from '../domain/note'
import { isLinkOnlyMarkdown } from '../utils/markdownText'
import { authoredUrlLabelInMarkdown } from '../utils/urlIntake'

/** Display-only: keep manual headings and unresolved fallbacks, without duplicating a known link title. */
export function linkOnlyEditorTitle(
  body: string,
  urls: UrlEntity[],
  note: Pick<Note, 'manualTitle' | 'derivedTitle'> | null | undefined,
  hasImages = false,
): string | null {
  const authoredLabel = urls.length === 1 && authoredUrlLabelInMarkdown(body, urls[0]!)
  if (!authoredLabel && !isLinkOnlyMarkdown(body, urls.length)) return null
  const manualTitle = note?.manualTitle?.trim()
  if (manualTitle) return manualTitle
  if (authoredLabel || urls.some((url) => isUsableUrlTitle(url, url.title))) return null
  return note?.derivedTitle ?? deriveTitle(body, urls, hasImages)
}
